enum SearchCustomerEnum {
    msisdn = "msisdn",
    passport = "passport",
    national_id = "national_id",
    birth_certificate = "birth_certificate",
    billing_account = "billing_account",
    individual_tax_number = "individual_tax_number",
}

export { SearchCustomerEnum };